import { render, staticRenderFns } from "./AccountBody.vue?vue&type=template&id=6a58a0b7&scoped=true"
import script from "./AccountBody.vue?vue&type=script&lang=js"
export * from "./AccountBody.vue?vue&type=script&lang=js"
import style0 from "./AccountBody.vue?vue&type=style&index=0&id=6a58a0b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a58a0b7",
  null
  
)

export default component.exports